import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import ListItemWap from './ListItemWap';
import ModalPopover from './../../../../../components/ZUILib/ModalPopover';
import InputButton from './../../../../../components/ZUILib/InputButton';
import Image from './../../../../../components/ZUILib/Image';
import RadioButton from './../../../../../components/ZUILib/RadioButton';
import Warning from './../../../../../components/Warning';
import Tagging from '../../../../../components/Tagging';

import serverClientUtil from '../../../../../utils/serverClientUtil';
import commonUtil from '../../../../../utils/commonUtil';
import { closeWebGiftListIcon, deleteWebModalIcon ,AddWebModalIcon,starWebGiftListIcon ,helpWebGiftListIcon, triangleWapGiftListIcon } from '../../../../../components/NewHeader/Header/svgIcons';

import { addItemToCartAditionalDataLayer, addItemToCartDataLayer, handleUserExpressCheckoutBuyDataLayer, initShowContenWapDataLayer } from './dataLayerListWap';
import * as BrowseAndNevigateMiniCartAction from '../../../../../pages/BrowseAndNavigate/MiniCart/actions';
import * as giftListGuestViewAction from '../actions';
import TextInput from '../../../../../components/ZUILib/TextInput';

const {
  additemtocart,
  additemtoexpresscart,
  getConfiguration: getConfigurationService,
} = giftListGuestViewAction;

const { getCartCountData } = BrowseAndNevigateMiniCartAction;

class ListContainerWap extends Component {
  constructor(props) {
    super(props);
    this.index = '';
    this.itemInfo = {};
    this.addressId = '';
    this.ownerName = '';
    this.gifteeRefs = [];
    this.categoryName = '';
    this.recipientIndex = '';
    this.previousQuantity = 1;
    this.itemDataForPopup = {};
    this.getAddressObject = {};
    this.eventRecipientIndex = '';
    this.selectGifteePerson = undefined;
    this.giftsPerPage = this.props.giftsPerPage;
    this.gifthList = this.props.gifthList ? this.props.gifthList : '';
    this.guestViewGiftListDetails = this.props.guestViewGiftListData ? this.props.guestViewGiftListData : '';
    //this.getConfiguration();

    this.state = {
      isFav: false,
      count: 0,
      addToCartSuccess: false,
      expressCheckoutEnabled: false,
       isHelp: false,
       numericQuantity: this.previousQuantity,
    };
  }

  productTypeMap = {
    SOFT_LINE: 'SL',
    GIFT_CERTIFICATE: 'GC',
    BIG_TICKET: 'BT'
  };

  // getConfiguration = () => {
  //   const payload = {
  //     brandName: commonUtil.getBrand(),
  //   };

  //   getConfigurationService(payload).then((response) => {
  //     const { body } = response || {};
  //     const { configuration, status = '' } = body || {};
  //     const { expressCheckoutConfiguration } = configuration || {};

  //     if (status.status === 'SUCCESS') {
  //       if (!commonUtil.isEmpty(expressCheckoutConfiguration)) {
  //         const expressCheckoutEnabled = expressCheckoutConfiguration.expressCheckoutEnabled === 'true';
  //         this.setState({ expressCheckoutEnabled });
  //       }
  //     }
  //   // eslint-disable-next-line no-console
  //   }).catch((e) => { console.log(e); });
  // }

  selectedPersonData = (event) => {
    const selectedCelebratedId = event.id.replace('id_', '');
    this.addressId = _.find(this.props.guestViewGiftListData && this.props.guestViewGiftListData.celebratedList, { celebratedId: selectedCelebratedId }).addressId;
    this.recipientIndex = event.value;
    this.ownerName = event.displayName;
  }

  increment = () =>
    this.setState({
      count: this.state.count < 999
        ? this.state.count + 1
        : this.state.count,
    })

  decrement = () =>
  this.setState({
    count: this.state.count >= 2
      ? this.state.count - 1
      : 1,
  });

  closeModal=() => {
    this.setState({
      addToCartSuccess: false,
    });
    this.contentModalWap.handleHide();
  }

  quantityUpdate = (e) => {
    if (e.target.value !== '0' && e.target.value.length <= 3) {
      this.setState({
        count: parseInt(e.target.value, 10) });
    }

    if (e.target.value === '0') {
      this.setState({
        count: parseInt(this.previousQuantity, 10),
      });
    }
  }

  showContentWap = (itemData, categoryName, index) => {

    this.itemDataForPopup = itemData;
    this.categoryName = categoryName;
    this.index = `${index + 1}`;
    this.previousQuantity = 1;
    this.resetModalData();
    this.contentModalWap.handleShow();


    this.setState({
      count: parseInt(this.itemDataForPopup.quantity, 10),
      isFav: itemData.isFavourite,
      numericQuantity: itemData.quantity || 1
    });

    const certificateWapName = commonUtil.getLabel(this.lables.GuestviewPage, 'guestview.gift.certificate.name.label');

    const imgRef = document.querySelector('#productModalGuest div.productImgModal img');
    if (categoryName === certificateWapName) {
      imgRef.src = commonUtil.getAssetURL() + '/images/certificado.jpg';
    } else {
      imgRef.src = itemData.imageURL;
    }

    const productName = document.querySelector('#productModalGuest p.titleProductModal');
    productName.innerText = itemData.name;

    const skuId = document.querySelector('#productModalGuest p.skuId');
    skuId.innerHTML = `<strong>SKU:</strong> ${itemData?.skuId || ''}`;
    if (Number(itemData.salePrice) <= Number(itemData.listPrice) && categoryName !== commonUtil.getLabel(this.lables.GuestviewPage, 'guestview.gift.certificate.name.label')) {
      const salePrice = document.querySelector('#productModalGuest p.salePrice');
      salePrice.innerHTML = commonUtil.getHtmlCurrency(itemData.listPrice);

      const priceProduct = document.querySelector('#productModalGuest p.priceProduct');
      priceProduct.innerHTML = commonUtil.getHtmlCurrency(itemData.salePrice);
    } else {
      const salePrice = document.querySelector('#productModalGuest p.priceProduct');
      salePrice.innerHTML = commonUtil.getHtmlCurrency(itemData.listPrice);
    }

    this.gifteeRefs.forEach((rad) => {
      if (rad != null) {
        rad.setChecked(false);
        if (rad.props.id === this.props.gifteeId) {
          rad.setChecked(true);
        }
      }
    });

    this.celebratedId = this.props.gifteeId;
    const celebrity = _.find(this.props.celebratedList, { celebratedId: this.celebratedId });
    this.recipientIndex = celebrity ? celebrity.recipientIndex : '';
    this.addressId = celebrity ? celebrity.addressId : this.guestViewGiftListDetails.celebratedList[0].addressId;

    initShowContenWapDataLayer({
      eventId: this.props.eventId,
      itemData,
      previousQuantity: this.previousQuantity,
      index,
      categoryName,
    });
  }

  componentDidUpdate(prevProps) {
  if (!prevProps.addToCartSuccess && this.props.addToCartSuccess) {
    this.props.getCartCountData();
    this.props.getGiftListGuestView(this.props.eventId, '', '', '1', 'false', this.giftsPerPage);
    this.setState({ addToCartSuccess: true });
    this.props.clearSelectedFilter();
    this.props.displayAlertMessage(commonUtil.getLabel(this.props?.labels?.GuestviewPage, 'guestview.gift.added.to.cart.success.message'), 'success');
    this.closeModal();
    this.props.goToTop();
  }

  if (this.props.addToCartError && prevProps.addToCartError !== this.props.addToCartError) {
    console.error('Add to cart failed:', this.props.addToCartError);
    const errorMsg = 
      typeof this.props.addToCartError === 'string' ? this.props.addToCartError :
      this.props.addToCartError?.errorMessage ||
      this.props.addToCartError?.message ||
      'Add to cart failed.';
    this.props.displayAlertMessage(errorMsg, 'error');
    this.closeModal();
    this.props.goToTop();
  }

  if (!prevProps.expressCheckoutSuccess && this.props.expressCheckoutSuccess) {

    const isLoggedIn = !!(this.props.user && this.props.user.profileId);

    if (isLoggedIn) {
      location.href = serverClientUtil.getLPURL() + '/tienda/oneCheckout?isBuyNow=true';
    } else {
      commonUtil.handleRedirect(true);
    }

   // this.props.displayAlertMessage('Express checkout successful!', 'success');
    this.closeModal();
  }

  if (this.props.expressCheckoutError && prevProps.expressCheckoutError !== this.props.expressCheckoutError) {
    console.error('Express checkout failed:', this.props.expressCheckoutError);
    const errorMsg =
      typeof this.props.expressCheckoutError === 'string' ? this.props.expressCheckoutError :
      this.props.expressCheckoutError?.errorMessage ||
      this.props.expressCheckoutError?.message ||
      'Express checkout failed.';
    this.props.displayAlertMessage(errorMsg, 'error');
    this.closeModal();
  }
}

  sanitizeAddress = (address) => {
    if (!address || typeof address !== "object") return {};
  
    return {
      firstName: address.firstName || "",
      lastName: address.lastName || "",
      country: address.country || "",
      phoneNumber: address.phoneNumber || "",
      address2: address.address2 || "",
      city: address.city || "",
      address1: address.address1 || "",
      postalCode: address.postalCode || "",
      state: address.state || ""
    };
  }

  handleUserAction = async () => {
    await commonUtil.ensureAnonymousSession(this.props?.user);

    this.itemInfo = {
      productName: this.itemDataForPopup.name,
      productType: this.itemDataForPopup.productType,
      deliveryMode: this.itemDataForPopup.deliveryMode,
      skuId: this.itemDataForPopup.skuId,
      listPrice: this.itemDataForPopup.listPrice,
      salePrice: this.itemDataForPopup.salePrice,
      quantity: this.previousQuantity,
    };

    if (this.itemDataForPopup.departmentId !== '') { this.itemInfo.departmentId = this.itemDataForPopup.departmentId; }
    if (this.itemDataForPopup.color !== '') { this.itemInfo.color = this.itemDataForPopup.color; }
    if (this.itemDataForPopup.size !== '') { this.itemInfo.size = this.itemDataForPopup.size; }
    if (this.itemDataForPopup.texture !== '') { this.itemInfo.texture = this.itemDataForPopup.texture; }
    if (this.itemDataForPopup.material !== '') { this.itemInfo.material = this.itemDataForPopup.material; }
    if (this.itemDataForPopup.imageURL !== '') { this.itemInfo.imageURL = this.itemDataForPopup.imageURL; }

    this.eventRecipientIndex =
      this.itemDataForPopup.eventRecipientIndex
        ? this.itemDataForPopup.eventRecipientIndex
        : '';

    const addressTempId = (this.itemDataForPopup.addressId && this.itemDataForPopup.addressId.trim().length > 2)
      ? this.itemDataForPopup.addressId.trim()
      : this.addressId;

    const addItemToCartDetails = {
      brand: commonUtil.getBrand(),
      channel:'WEB',
      productInfo: this.itemInfo,
      eventInfo: {
        eventId: this.guestViewGiftListDetails.eventInfo.eventId,
        eventType: this.guestViewGiftListDetails.eventInfo.eventType,
        eventDate: this.guestViewGiftListDetails.eventInfo.eventDate,
        celebrity1Name: this.guestViewGiftListDetails.celebratedList[0].celebratedName,
        recipientIndex: this.eventRecipientIndex.trim() !== ''
         ? parseInt(this.eventRecipientIndex, 10)
         : this.recipientIndex.trim() !== '' 
         ? parseInt(this.recipientIndex, 10) : 1,
        ownerName: this.ownerName
          ? this.ownerName
          : !_.isEmpty(this.props.gifteeName) ? _.find(this.guestViewGiftListDetails.celebratedList, { celebratedId: this.props.gifteeName }).celebratedName : this.guestViewGiftListDetails.celebratedList[0].celebratedName,
        address: 'address',
      },
    };

    addItemToCartDetails.productInfo.productType = this.productTypeMap[this.itemInfo.productType] ?? this.itemInfo.productType;

    if (this.guestViewGiftListDetails.celebratedList && this.guestViewGiftListDetails.celebratedList[1] && this.guestViewGiftListDetails.celebratedList[1] !== '') {
      addItemToCartDetails.eventInfo.celebrity2Name = this.guestViewGiftListDetails.celebratedList[1].celebratedName;
    }

    if (this.recipientIndex && this.eventRecipientIndex.trim() !== '' && this.recipientIndex !== this.eventRecipientIndex) {
      addItemToCartDetails.eventInfo.selectedRecipientIndex = parseInt(this.recipientIndex, 10);
    }

    if(addressTempId){
      addItemToCartDetails.eventInfo.address = this.props.guestViewGiftListData.addressInfo.find(address => address.addressId == addressTempId);
    }else{
      addItemToCartDetails.eventInfo.address = this.props.guestViewGiftListData.addressInfo[0];
    }

    const address = addItemToCartDetails?.eventInfo?.address;
    if (address && typeof address === "object" && Object.keys(address).length) {
      addItemToCartDetails.eventInfo.address = this.sanitizeAddress(address);
    }

    this.props.additemtocart(addItemToCartDetails);
  }

  handleUserExpressCheckoutBuyNowAction = async () => {

    this.itemInfo = {
      productName: this.itemDataForPopup.name,
      productType: this.itemDataForPopup.productType,
      deliveryMode: this.itemDataForPopup.deliveryMode,
      skuId: this.itemDataForPopup.skuId,
      listPrice: this.itemDataForPopup.listPrice,
      salePrice: this.itemDataForPopup.salePrice,
      quantity: this.previousQuantity,
    };

    if (this.itemDataForPopup.departmentId !== '') { this.itemInfo.departmentId = this.itemDataForPopup.departmentId; }
    if (this.itemDataForPopup.color !== '') { this.itemInfo.color = this.itemDataForPopup.color; }
    if (this.itemDataForPopup.size !== '') { this.itemInfo.size = this.itemDataForPopup.size; }
    if (this.itemDataForPopup.texture !== '') { this.itemInfo.texture = this.itemDataForPopup.texture; }
    if (this.itemDataForPopup.material !== '') { this.itemInfo.material = this.itemDataForPopup.material; }
    if (this.itemDataForPopup.imageURL !== '') { this.itemInfo.imageURL = this.itemDataForPopup.imageURL; }
    this.eventRecipientIndex = this.itemDataForPopup.eventRecipientIndex
      ? this.itemDataForPopup.eventRecipientIndex
      : '';
    const addressTempId = (this.itemDataForPopup.addressId && this.itemDataForPopup.addressId.trim().length > 2)
      ? this.itemDataForPopup.addressId.trim()
      : this.addressId;

    const addItemToCartDetails = {
      channel:'WEB',
      brand: commonUtil.getBrand(),
      productInfo: this.itemInfo,
      eventInfo: {
        eventId: this.guestViewGiftListDetails.eventInfo.eventId,
        eventType: this.guestViewGiftListDetails.eventInfo.eventType,
        eventDate: this.guestViewGiftListDetails.eventInfo.eventDate,
        celebrity1Name: this.guestViewGiftListDetails.celebratedList[0].celebratedName,
        recipientIndex: this.eventRecipientIndex.trim() !== '' ? parseInt(this.eventRecipientIndex, 10) : parseInt(this.recipientIndex, 10),
        ownerName: this.ownerName ? this.ownerName : !_.isEmpty(this.props.gifteeName) ? _.find(this.guestViewGiftListDetails.celebratedList, { celebratedId: this.props.gifteeName }).celebratedName : this.guestViewGiftListDetails.celebratedList[0].celebratedName,
        address: 'address',
      },
    };
    if (this.guestViewGiftListDetails.celebratedList && this.guestViewGiftListDetails.celebratedList[1] && this.guestViewGiftListDetails.celebratedList[1] !== '') {
      addItemToCartDetails.eventInfo.celebrity2Name = this.guestViewGiftListDetails.celebratedList[1].celebratedName;
    }
    if (this.recipientIndex && this.eventRecipientIndex.trim() !== '' && this.recipientIndex !== this.eventRecipientIndex) {
      addItemToCartDetails.eventInfo.selectedRecipientIndex = parseInt(this.recipientIndex, 10);
    }

    addItemToCartDetails.productInfo.productType = this.productTypeMap[this.itemInfo.productType] ?? this.itemInfo.productType;

    if(addressTempId){
      addItemToCartDetails.eventInfo.address = this.props.guestViewGiftListData.addressInfo.find(address => address.addressId == addressTempId);
    }else{
      addItemToCartDetails.eventInfo.address = this.props.guestViewGiftListData.addressInfo[0];
    }

    const address = addItemToCartDetails?.eventInfo?.address;
    if (address && typeof address === "object" && Object.keys(address).length) {
      addItemToCartDetails.eventInfo.address = this.sanitizeAddress(address);
    }

    await commonUtil.ensureAnonymousSession(this.props?.user);

    this.props.additemtoexpresscart(addItemToCartDetails);
  }

  resetModalData = () => {
    this.setState({ addToCartSuccess: false });
    if (document.querySelector('span.error') || (this.state.addToCartSuccess === true)) {
      document.querySelector('span.error').style.display = 'none';
    }
    if (this.warning && this.warning.setMessage()) {
      this.warning.hideErrorMsg();
    }
  };
    
    handleHelpIconClick = () => {
    this.setState((prevState) => ({
      isHelp: !prevState.isHelp,
    }));
  }


  handleQuantityChange = (e) => {
      const value = e.target.value;

      if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
        this.previousQuantity = Number(value);
        this.setState({ numericQuantity: Number(value) });
    }
  }

    handleIncrement = () => {
    this.setState((prevState) => {
      const newQty = Math.min(999, Number(prevState.numericQuantity || 0) + 1);
      // this.props.onQuantityChange?.(newQty);
      this.previousQuantity = this.previousQuantity + 1;
      return { numericQuantity: newQty };
    });
  };

   handleDecrement = () => {
    this.setState((prevState) => {
      const newQty = Math.max(0, Number(prevState.numericQuantity || 0) - 1);
      // this.props.onQuantityChange?.(newQty);
      this.previousQuantity = this.previousQuantity - 1;
      return { numericQuantity: newQty };
    });
  };


  render() {
    this.lables = this.props.labels;
    const { guestViewGiftListData } = this.props;

    this.errorMessage =
      commonUtil.getLabel(this.lables.GuestviewPage, 'adminpage.addcart.service.fail.msg') + '.' + commonUtil.getLabel(this.lables.GuestviewPage, 'adminpage.addcart.service.fail.msg1') + '.';

    const headerData = (
      <React.Fragment>
        <div className="col-xs-9">
          <p className="titleModal">{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.product.gift.detail.label')}</p>
        </div>
        <div className="col-xs-3 product-btnClose">
          {/* <span>{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.close.label')}</span> */}
          <button className="btnClose" type="button" aria-label="Close" id="closeModal">{closeWebGiftListIcon}</button>
        </div>
      </React.Fragment>
    );

    const AddToMyBagButton = {
      type: 'button',
      value: commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.addtocart.button.label'),
      autoFocus: false,
      style: 'btnPrimarySpecial size-Full',
      // iconClass: 'iconRight icon-flecha_gruesa_derecha',
      onClickHandler: this.handleUserAction,
    };

    const ExpressCheckoutBuyNow = {
      type: 'button',
      value: 'Comprar ahora',
      autoFocus: false,
      style: 'btnPrimary size-Full',
      onClickHandler: this.handleUserExpressCheckoutBuyNowAction,
    };

    const ContinueShoppingButton = {
      type: 'button',
      value: commonUtil.getLabel(this.lables.EventAdminPage, 'adminpage.button.continue.buying'),
      autoFocus: false,
      style: 'btnPrimary continueShopping',
      onClickHandler: this.closeModal,
    };

    const _imgsrc = [
      {
        media: '(max-width: 465px)',
        srcSet: '',
      },
    ];

    const imageAttr = {
      src: this.itemDataForPopup.imageURL || '',
      id: 'm-link',
      altImg: this.itemDataForPopup?.altImageUrl || commonUtil.getAssetURL() + '/images/guest/no-image.png',
      width: 'auto',
      height: 'auto',
      pictureClassName: 'productImgModalImg',
    };

    if (guestViewGiftListData && guestViewGiftListData.celebratedList && guestViewGiftListData.celebratedList.length) {
      const celebratedList = guestViewGiftListData.celebratedList;
      if (celebratedList.length > 1) {
        this.selectGifteePerson = {
          name: 'selectGifteePerson',
          options: [],
        };

        this.selectGifteePerson.options = celebratedList.map(giftee => ({
          id: giftee.celebratedId,
          value: giftee.recipientIndex,
          displayName: giftee.celebratedName,
          subDetailsHTML: <p>{giftee.celebratedName}</p>,
          defaultChecked: this.props.gifteeId.toString() === giftee.celebratedId && giftee.celebratedId.length > 0,
        }));
      } else {
        this.selectGifteePerson = {
          id: celebratedList[0].celebratedId,
          value: celebratedList[0].recipientIndex,
          displayName: celebratedList[0].celebratedName,
        };
        this.selectedPersonData(this.selectGifteePerson);
      }
    }

    this.gifteeRefs = [];

    return (
      <React.Fragment>
        <Tagging ref={tagging => this.tagging = tagging} />
        <section style={{ clear: 'both', paddingBottom: 15 }}>
          {
            // this.props.guestViewGiftListData.itemsInfo
            this.props.gifthList
              ?
                <div style={{ display: 'flex', flexWrap: 'wrap', padding: '0 15px' }} className='list_wap_gift_container'>
                  {/* {this.props.guestViewGiftListData.itemsInfo.map((categoryInfo, index) => ( */}
                  {this.props.gifthList.map((categoryInfo, index) => (
                    <ListItemWap
                      index={index}
                      labels={this.props.labels}
                      categoryInfo={categoryInfo}
                      showContentWap={this.showContentWap}
                      eventId={this.guestViewGiftListDetails.eventInfo.eventId}
                    />))}
                </div>
              : null
          }
        </section>
        <ModalPopover ref={contentModal => this.contentModalWap = contentModal} dismiss="false" headerData={headerData} isModal="true" modalId="productModalGuest" contentStyle={{width:"100%", marginLeft:0}} >
          <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
            <div className='product-data-container'>
          <div className='product-data-wrapper'>
            <div className='productImgModal'>
                   <Image imageAttr={imageAttr} _imgsrc={_imgsrc} />
            </div>
            <div className='product-info-wrapper'>
                 <p className="titleProductModal" >
                  {this.itemDataForPopup.name}
                 </p>
                
                   {/* {
                this.itemDataForPopup.isFavourite ?
                  <div className="favouriteProduct">
                    <i className="icon-estrella_negativo" />
                    <span>{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.favourite.label')}</span>
                  </div> : null
              } */}
               <p className="skuId" >
                <strong>SKU:</strong>
                {this.itemDataForPopup?.skuId || ''}
               </p>
              {/* <p className="salePrice" /> */}
              <p className="priceProduct" >
                {commonUtil.getCurrency(this.itemDataForPopup.salePrice)}
              </p>
            </div>
          </div>
          <div className="row">
            {/*<div className="col-xs-12">
              <p className="titleProductModal" />
              <div className="productImgModal">
                <Image imageAttr={imageAttr} _imgsrc={_imgsrc} />
              </div>
            </div>*/}
            <div className="col-xs-12">
              {/* {
                this.itemDataForPopup.isFavourite ?
                  <div className="favouriteProduct">
                    <i className="icon-estrella_negativo" />
                    <span>{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.favourite.label')}</span>
                  </div> : null
              } */}
              {/* <p className="salePrice" /> */}
              {/* <p className="priceProduct" /> */}

                <div className="guest-gift-list-product-quantity-wrapper ">
                  <div className="quantity">{'Cantidad'}</div>
                  <div className="quantity-wrapper-guestlist">
                    {console.log("qnty===", this.state.numericQuantity)
                    }
                    <div className="">
                      <span
                        className="btn btn-default gift-quantity-btns btn-quantity-update"
                        onClick={this.previousQuantity <= 1 ? null : this.handleDecrement}
                        disabled={this.previousQuantity <= 1}
                      >
                        {this.previousQuantity <= 1 ? (deleteWebModalIcon) : (<span className='glyphicon glyphicon-minus' />)}
                      </span>
                    </div>
                    <div className=''>
                      <TextInput className="text-center input-number gift-quantity number-input-no-arrows" 
                      parentClassName="text_input_wrapper"
                      value={this.previousQuantity} 
                      name='quantity'
                      type="number"
                        min="0"
                        numeric ='numeric'
                        onKeyDown={(e) => {
                          if (e.key === "-" || e.key === "e") {
                            e.preventDefault();
                        }
                        }}
                      onPaste={(e) => {
                              const pasted = e.clipboardData.getData("text");
                        if (pasted.includes("-") || isNaN(pasted) || Number(pasted) < 0) {
                        e.preventDefault();
                      }
                      }}
                      onChange={this.handleQuantityChange}
                      />
                    </div>
                    <div className="">
                      <span
                        className="btn btn-default gift-quantity-btns btn-quantity-update"
                        onClick={this.handleIncrement}
                      >
                        {AddWebModalIcon}
                      </span>
                    </div>
                  </div>
                </div> 
                
              {/* {
                this.state.addToCartSuccess ?
                  <div className="row">
                    <div className="col-md-7 col-sm-7 col-offset-md-5 col-sm-offset-5 productAdded" id="productAdd" style={{ display: 'block' }}>
                      <i className="icon-estado_de_mensaje_aprobado" />
                      <span>
                        {commonUtil.getLabel(this.lables.GuestviewPage, 'guestview.you.added.by.label')}
                        <b> {this.state.count} {commonUtil.getLabel(this.lables.GuestviewPage, this.state.count < 2 ? 'guestview.product.by.label' : 'guestview.products.by.label')}</b>&nbsp;
                        {commonUtil.getLabel(this.lables.GuestviewPage, 'guestview.to.your.bag.by.label')}
                      </span>
                      <InputButton buttonAttr={ContinueShoppingButton} />
                    </div>
                  </div> :
                  <React.Fragment>
                    <p>{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.giftbuyinfor.label')}</p>
                    <span className="error" style={{ display: 'none' }}>{commonUtil.getLabel(this.lables.GuestviewPopupPage, 'guestviewpopup.owner.selection.bcc.text')}</span>
                    {
                      this.selectGifteePerson && this.selectGifteePerson.options &&
                        this.selectGifteePerson.options.map((option, index) => (
                          <RadioButton
                            changeOnPropsChange
                            ref={rad => this.gifteeRefs.push(rad)}
                            name={this.selectGifteePerson.name}
                            checked={option.defaultChecked}
                            id={'id_' + option.id}
                            key={index}
                            value={option.value}
                            displayName={option.displayName}
                            radioCssClass={'radio'}
                            onChangeFunction={event => this.selectedPersonData(event)}
                          />
                        ))
                    }
                    {this.selectGifteePerson && !this.selectGifteePerson.options && <p>{ this.selectGifteePerson.displayName}</p>}
                  </React.Fragment>
              } */}
            </div>
          </div>
          
          {
            this.state.isFav &&
            <div className='favorite-and-buttons-wrapper-guestlist'>
              <div className="help-text-wrapper">
              <p className="favorite-text">Regalo favorito</p>
              <span className='help-icon-guestlist' onClick={this.handleHelpIconClick}>{helpWebGiftListIcon}</span>
              </div>
              <span className='star-icon-guestlist'>{starWebGiftListIcon}</span>
              <p className='help-icon-text-container' style={{display: this.state.isHelp ? 'inline-block':'none'}}>El festejado lo eligió como uno de sus regalos más deseados.</p>
            </div>
          }
            </div>

            <div className="row giftlist-guest-show-buttons" id="showButton">
                <div className="col-xs-6 guest-btn-padding">
                  <InputButton buttonAttr={ExpressCheckoutBuyNow} />
                </div>
              <div className="col-xs-6 guest-btn-padding">
                <InputButton buttonAttr={AddToMyBagButton} />
              </div>
            </div>
        </ModalPopover>
      </React.Fragment>

    );
  }
}

const mapStateToProps = state => ({
  gifteeName: state.giftListGuestViewList.gifteeName,
  celebratedList: state.giftListGuestViewList.data.celebratedList,
  addToCartSuccess: state.giftListGuestViewList.addToCartSuccess,
  addToCartError: state.giftListGuestViewList.addToCartError,
  addToCartResponse: state.giftListGuestViewList.addToCartResponse,
  expressCheckoutSuccess: state.giftListGuestViewList.expressCheckoutSuccess,
  expressCheckoutError: state.giftListGuestViewList.expressCheckoutError,
  expressCheckoutResponse: state.giftListGuestViewList.expressCheckoutResponse,
  user: state.user && state.user.data && state.user.data.result,
});

const matchDispatchToProps = dispatch => bindActionCreators(
  {
    getCartCountData,
    additemtocart,
    additemtoexpresscart
  }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(ListContainerWap);
